import React from 'react';
import {JourneyInfoHead} from './JourneyInfoHead/JourneyInfoHead';
import {DisruptionInfo} from './DisruptionInfo/DisruptionInfo';




 function Disruption () {
  return (
    <div className="Disruption">

      <JourneyInfoHead />

      <DisruptionInfo />

         
              
    </div>
  );
}

export default Disruption;